export const RECEIVE_SKIN_INFO = "design/skin/RECEIVE_SKIN_INFO"
